export const mapsSkeletonStyles = {
  wrapper: {
    mt: {
      mobile: "-5rem",
      tablet: "-2rem",
      laptop: "0",
    },
    mx: {
      mobile: "auto",
      tablet: "2.5rem",
      laptop: "auto",
    },
    maxWidth: {
      laptop: "69.438rem",
    },
  },
  container: {
    height: {
      tablet: "39rem",
      laptop: "20.375rem",
    },
    width: {
      tablet: "100%",
    },
    mx: {
      mobile: "auto",
    },
  },
  imageSkeleton: {
    height: {
      mobile: "30rem",
    },
    width: {
      laptop: "20.375rem",
    },
    mr: {
      laptop: "1.25rem",
      desktop: "unset",
    },
  },
  textWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: {
      mobile: "center",
      tablet: "space-between",
      laptop: "flex-start",
    },
    flexDirection: {
      mobile: "column",
      tablet: "row",
    },
    width: {
      laptop: "46.625rem",
    },
    mx: {
      laptop: "2rem",
    },
  },
  textContainerOuter: {
    mr: {
      laptop: "2rem",
    },
    alignItems: {
      mobile: "center",
      laptop: "unset",
    },
  },
  title: {
    width: {
      mobile: "12.5rem",
    },
    mb: {
      mobile: "1.5rem",
    },
  },
  textContainerTop: {
    mb: {
      mobile: "1.5rem",
      laptop: "3rem",
    },
  },
  text: {
    width: {
      mobile: "18.75rem",
    },
  },
};
